import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="pt-32 pb-20">
        <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
            <p className="text-gray-600 mb-8">Last updated: January 2025</p>

            <div className="prose prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">1. Information We Collect</h2>
                <p className="text-gray-600 mb-4">
                  At FourQ Learn, we collect information that you provide directly to us, including:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Name, email address, phone number, and other contact information</li>
                  <li>Student grade level, subjects of interest, and learning preferences</li>
                  <li>Payment information (processed securely through third-party payment processors)</li>
                  <li>Session recordings and learning progress data</li>
                  <li>Communications between students, parents, and tutors</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">2. How We Use Your Information</h2>
                <p className="text-gray-600 mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Provide, maintain, and improve our tutoring services</li>
                  <li>Match students with appropriate tutors</li>
                  <li>Process payments and manage subscriptions</li>
                  <li>Send important updates about sessions and platform features</li>
                  <li>Generate progress reports and learning analytics</li>
                  <li>Respond to customer support inquiries</li>
                  <li>Ensure platform safety and prevent fraud</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">3. Information Sharing</h2>
                <p className="text-gray-600 mb-4">
                  We do not sell your personal information. We may share your information with:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Tutors assigned to your sessions (only necessary educational information)</li>
                  <li>Service providers who help us operate our platform (under strict confidentiality agreements)</li>
                  <li>Law enforcement when required by law or to protect rights and safety</li>
                  <li>Parents or guardians (for minor students)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">4. Data Security</h2>
                <p className="text-gray-600">
                  We implement industry-standard security measures to protect your information, including:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-4">
                  <li>Encryption of data in transit and at rest</li>
                  <li>Regular security audits and vulnerability assessments</li>
                  <li>Strict access controls and authentication requirements</li>
                  <li>Secure payment processing through PCI-DSS compliant providers</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">5. Your Rights</h2>
                <p className="text-gray-600 mb-4">
                  You have the right to:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-2">
                  <li>Access and download your personal data</li>
                  <li>Correct inaccurate or incomplete information</li>
                  <li>Request deletion of your account and associated data</li>
                  <li>Opt-out of marketing communications</li>
                  <li>Request session recordings be deleted after review</li>
                </ul>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">6. Children's Privacy</h2>
                <p className="text-gray-600">
                  Our services are designed for students aged 8 and above. For students under 18, we require parental consent. Parents have full access to their child's account and can review all collected information.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">7. Cookies and Tracking</h2>
                <p className="text-gray-600">
                  We use cookies and similar technologies to enhance your experience, analyze platform usage, and improve our services. You can control cookie preferences through your browser settings.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">8. Updates to This Policy</h2>
                <p className="text-gray-600">
                  We may update this Privacy Policy from time to time. We will notify you of any significant changes via email or platform notification. Your continued use of our services after changes constitutes acceptance of the updated policy.
                </p>
              </section>

              <section>
                <h2 className="text-3xl font-bold text-gray-900 mb-4">9. Contact Us</h2>
                <p className="text-gray-600">
                  If you have questions about this Privacy Policy or how we handle your information, please contact us at:
                </p>
                <div className="bg-cyan-50 rounded-xl p-6 mt-4">
                  <p className="text-gray-900 font-semibold">Email: contact@fourqlearn.com</p>
                  <p className="text-gray-900 font-semibold">Phone: +91 9538667790</p>
                  <p className="text-gray-900 font-semibold">Address: I-704, Smondo 3.0, Neotown, Electronics City Phase 1, Bangalore-560100</p>
                </div>
              </section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;